<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        税号列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;" class="search-box">
        <el-row class="search">
          <el-col :span="2">
            <div class="label">公司名称:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="company_name" clearable size="small" placeholder="公司名称"></el-input>
          </el-col>
          <el-col :span="14" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <div class="center_list_head_rig" @click="dialogFormVisible1 = true,editId='',add_company= '',
          add_duty_code= '',
          register_address= '',
          register_phone= '',
          open_user_bank= '',
          open_card_number= '' ">添加公司税号</div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="company_name" label="公司名称" align="center"></el-table-column>
        <el-table-column prop="duty_code" label="税号" align="center"></el-table-column>
        <el-table-column prop="register_address" label="注册地址" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="register_phone" label="注册电话" align="center"></el-table-column>
        <el-table-column prop="open_user_bank" label="开户银行" align="center"></el-table-column>
        <el-table-column prop="open_card_number" label="银行账户" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="red(scope.row.id)" class="button1">删除</button>
            <button @click="dialogFormVisible1 = true,edit(scope.row.id,scope.row)" class="button1">编辑</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col>
            <el-pagination
              style="text-align:center"
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  <noAccess v-else></noAccess>
    <!-- 添加用户 -->
    <el-dialog title="添加税号" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="公司名称:">
          <el-input style="width:356px" v-model="add_company" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　　税号:">
          <el-input style="width:356px" v-model="add_duty_code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="注册地址:">
          <el-input style="width:356px" v-model="register_address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="注册电话:">
          <el-input style="width:356px" v-model="register_phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开户银行:">
          <el-input style="width:356px" v-model="open_user_bank" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="银行账户:">
          <el-input style="width:356px" v-model="open_card_number" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return { serve: this.$store.state.serve,
      token: this.$cookies.get('token'),
      username: this.$cookies.get('username'),
      role:true,
      page: null,
      total: 0,
      tableData: [],
      company_name: '',
      add_company: '',
      add_duty_code: '',
      register_address: '',
      register_phone: '',
      open_user_bank: '',
      open_card_number: '',
      editId: '',
      dialogFormVisible1: false,
      id: '',
      name: null,
    }
  },
  created() {
    this.$store.state.topActiveId = 4
    this.$store.state.leftTitle = '编辑税号'
    this.geting()
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection()
      } else {
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleAllSelection()
      }
    }
  },
  methods: {
    edit(id,data){
      if(id > 0){
          this.add_company = data.company_name; 
          this.add_duty_code = data.duty_code;
          this.register_address = data.register_address;
          this.register_phone = data.register_phone;
          this.open_user_bank = data.open_user_bank;
          this.open_card_number = data.open_card_number;
          this.editId = data.id;
      }
       
    },
    red(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios
            .get(this.serve+'/admin/del_duty_code', {
              params: {
                username: this.username,
                token: this.token,
                id
              }
            })
            .then(res => {
              if (res.data.status == 'success') {
                this.geting()
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
              } else if (res.data.status == 'error') {
                this.$message.error(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    submit(id) {
      //弹窗提交
      if (this.add_company == '') {
        this.$message.error('请输入公司名称')
        return
      }
      if (this.add_duty_code == '') {
        this.$message.error('请输入税号')
        return
      }
      const _this = this

      this.axios
        .get(this.serve+'/admin/add_duty_code', {
          params: {
            username: this.username,
            token: this.token,
            duty_code: this.add_duty_code,
            company_name: this.add_company,
            register_address: this.register_address,
            register_phone: this.register_phone,
            open_user_bank: this.open_user_bank,
            open_card_number: this.open_card_number,
            id: this.editId

          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            _this.$message({
              type: 'success',
              message: '操作成功'
            })
            _this.geting()
            _this.dialogFormVisible1 = false
          } else if (res.data.status == 'error') {
            _this.$message.error(res.data.msg)
          }
        })
    },

    setPage(v) {
      //分页

      this.page = v
      this.geting(v)
      this.selectAll = false
    },

    geting(page) {
      //请求数据
      var that = this
      this.axios
        .get(this.serve+'/admin/duty_list', {
          params: {
            token: this.token,
            username: this.username,
            company_name: this.company_name,
            page
          }
        })
        .then(res => {
          that.tableData = []
          var json = res.data.data
          if (res.data.status == 'success') {
            that.total = res.data.data.total
            that.page = res.data.data.page
            that.tableData = json.results
          }else{
            if(res.data.msg == "无权访问")
            {
              this.role = false
            }
          }
          
        })
    }
  }
}
</script>
<style lang="scss">
.list {
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: left!important;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>